// extracted by mini-css-extract-plugin
export var label = "_j3-2";
export var slideContainer = "_j3-0";
export var slider = "_j3-1";